import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.user',
    modules: [
        R,
    ],
})
@Service('UserStore')
export default class UserStore extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('users');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/user.js